import { createSelector } from 'reselect';

const selectSmsCampaigns = (state: any) => state.smsCampaigns;


export const selectSmsCampaignsCurrentItem = createSelector([selectSmsCampaigns], (smsCampaigns) => smsCampaigns.current);

export const selectSmsCampaignsListItems = createSelector([selectSmsCampaigns], (smsCampaigns) => smsCampaigns.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectSmsCampaignsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSmsCampaignsCreatedItem = createSelector([selectSmsCampaigns], (smsCampaigns) => smsCampaigns.create);
export const selectSmsCampaignsQueryItems = createSelector([selectSmsCampaigns], (smsCampaigns) => smsCampaigns.query);
export const selectSmsCampaignsUpdatedItem = createSelector([selectSmsCampaigns], (smsCampaigns) => smsCampaigns.update);

export const selectSmsCampaignsReadItem = createSelector([selectSmsCampaigns], (smsCampaigns) => smsCampaigns.read);

export const selectSmsCampaignsDeletedItem = createSelector([selectSmsCampaigns], (smsCampaigns) => smsCampaigns.delete);

export const selectSmsCampaignsSearchedItems = createSelector([selectSmsCampaigns], (smsCampaigns) => smsCampaigns.search);

export const selectSmsCampaignsItemsCount = createSelector([selectSmsCampaigns], (smsCampaigns) => smsCampaigns.count);

export const selectSmsCampaignsItemsFilter = createSelector([selectSmsCampaigns], (smsCampaigns) => smsCampaigns.filter);